// extracted by mini-css-extract-plugin
module.exports = {"root":"_2mpmx","content":"_3Ovaw","rootHome":"_2pf6H","logo":"_1UgXJ"};